export const escape = (str) => (str ? str.replace(/<\/script/g, '<\\/script').replace(/<!--/g, '<\\!--') : '');
